const { io } = require('./ioHandler');
const { reactRender } = require('./reactRender');

const defaultCustomGameSettings = { 
  maxWins: { value: 5, min: 2, max: 20 },
  maxBullets: { value: 10, min: 2, max: 40, jumpBy: 2 },
  walls: { value: 140, min: 15, max: 400, jumpBy: 15 },
  revealTimer: { value: 35, min: 20, max: 120, jumpBy: 5 },
  
  bulletCancel: { value: 35, min: 20, max: 120, jumpBy: 5 },

  deathZones: { value: 1 },
  miniDeathZones: { value: 1 },
  scanBars: { value: 1 },
  invisFields: { value: 1 },
  powerups: { value: 1 },

  powerupsDisabled: { },
  powerupNames: [
    "Invis",
    "Teleport",
    "Decoy",
    "Blackout",
    "Shield",
    "Shotgun",
    "Range",
    "Reveal",
    "Speed",
    "Rapid Fire",
    "Radar Shots",
    "Poison Shot",
  ],

  specialRound: 5, // cycles between special round.  Options are "none (-1), all (1), 3, and 5"
};
let customGameSettings = JSON.parse(JSON.stringify(defaultCustomGameSettings));


// Note we pass backToLobby here to avoid the circular dependency
// TODO (Peter) come up with a better framework for avoiding these (maybe like on backend)
function initCustomGameLobby(isAdmin, gameId, inBackToLobby, initGame) {

  console.log("initCustomGameLobby: " + gameId, isAdmin);

  var backToLobby = () => {
    endCustomGameLobby();
    inBackToLobby();
  }

  constructCustomGameLobbyHTML(isAdmin, gameId, backToLobby);
  io.on('matchMade', () => {
    endCustomGameLobby();
    reactRender.nothing();
    initGame();
  });
  io.on('kicked', () => {
    endCustomGameLobby();
    backToLobby();
    setTimeout(reactRender.showAlert("Disconnected from lobby"), 200);
  })
}

function kickUser(id) {
  io.emit('kickUser', {userIdToKickSessionId: id});
}

function addBot() {
  io.emit('addBot', true);
}

function setBotLevel(level) {
  io.emit('setBotLevel', level);
}

function clickStartGame(players, customGameSettings) {
  if (players.length > 1) {
    io.emit('startGame', customGameSettings);
  } else
    reactRender.showAlert("You need more than one player to start a game")
}

let settingsOverlayOpen = false;

function renderLobby(clickBack, gameId, players, isAdmin, numBots, botLevel, customGameSettings) {

  var renderPlayers = [];
  for (var i = 0; i < players.length; i++) 
    renderPlayers.push(players[i]);
  for (var i = 0; i < numBots; i++) 
    renderPlayers.push({name: "lvl " + botLevel + " bot", sessionId: ""});

  const roomName = players.length > 0 ? players[0].name + "\'s room" : "";

  let clickSettings;

  const resetToDefault = function() {

    for (let key in defaultCustomGameSettings)
      customGameSettings[key] = JSON.parse(JSON.stringify(defaultCustomGameSettings[key]));

    reactRender.lobby(clickBack, roomName, gameId, renderPlayers, isAdmin, 
      () => clickStartGame(renderPlayers, customGameSettings), kickUser, addBot, setBotLevel, numBots, botLevel, settingsOverlayOpen, clickSettings, customGameSettings, reRender, resetToDefault);
  }

  reRender = function() {
    reactRender.lobby(clickBack, roomName, gameId, renderPlayers, isAdmin, 
      () => clickStartGame(renderPlayers, customGameSettings), kickUser, addBot, setBotLevel, numBots, botLevel, settingsOverlayOpen, clickSettings, customGameSettings, reRender, resetToDefault);
  }

  clickSettings = function() {
    settingsOverlayOpen = !settingsOverlayOpen;
    console.log("settingsOverlayOpen", settingsOverlayOpen);
    reactRender.lobby(clickBack, roomName, gameId, renderPlayers, isAdmin, 
      () => clickStartGame(renderPlayers, customGameSettings), kickUser, addBot, setBotLevel, numBots, botLevel, settingsOverlayOpen, clickSettings, customGameSettings, reRender, resetToDefault);
    io.emit('gameSettings', customGameSettings);
  }

  reactRender.lobby(clickBack, roomName, gameId, renderPlayers, isAdmin, 
    () => clickStartGame(renderPlayers, customGameSettings), kickUser, addBot, setBotLevel, numBots, botLevel, settingsOverlayOpen, clickSettings, customGameSettings, reRender, resetToDefault);
}


function constructCustomGameLobbyHTML(isAdmin, gameId, clickBack) {

  settingsOverlayOpen = false;
  let players = [];
  let numBots = 0;
  let botLevel = 3;

  reactRender.lobby(clickBack, "", gameId, players, isAdmin);

  io.on('userJoined', params => {
    var sound = document.getElementById("join");
    sound.play();

    players.push(params);
    renderLobby(clickBack, gameId, players, isAdmin, numBots, botLevel, customGameSettings);
  });

  io.on('gameSettings', params => {
    customGameSettings = params;
    renderLobby(clickBack, gameId, players, isAdmin, numBots, botLevel, customGameSettings); 
  });

  io.on('botData', params => { 
    botLevel = params.botLevel;
    numBots = params.numBots;
    renderLobby(clickBack, gameId, players, isAdmin, numBots, botLevel, customGameSettings); 
  });

  io.on('userLeft', params => {

    for (var i = 0; i < players.length; i++)
    {
      if (players[i].sessionId == params.sessionId)
      {
        players.splice(i, 1);
        break;
      }
    }

    renderLobby(clickBack, gameId, players, isAdmin, numBots, botLevel, customGameSettings);
  });
}

function endCustomGameLobby() {
  io.off('userLeft');
  io.off('matchMade');
  io.off('kicked');
  io.off('userLeft');
  io.off('gameSettings');

  // document.body.removeChild(customGameLobbyDiv);
}

module.exports = {
  initCustomGameLobby,
}
